export function formatOfferDeadline(offer: { dueAt: string; offerExpiresAt?: string }) {
  const targetDate = offer.offerExpiresAt ?? offer.dueAt;
  const target = new Date(targetDate).getTime();
  const deltaMs = target - Date.now();
  if (deltaMs <= 0) return offer.offerExpiresAt ? "Expired" : "Due now";
  const totalMinutes = Math.ceil(deltaMs / 60_000);
  if (totalMinutes >= 1_440) return new Date(targetDate).toLocaleDateString();
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours >= 1) return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  return `${totalMinutes}m`;
}
